const commentsData = [
  {
    name: '影视爱好者小王',
    time: '3天前',
    content: '之前一直只用香蕉视频，通过青青草才发现红桃视频的原创内容这么精彩，现在两个平台换着看，体验翻倍！聚合站真的太方便了。',
    platform: '香蕉视频 & 红桃视频',
    rating: 5,
  },
  {
    name: '高清画质控',
    time: '5天前',
    content: '蜜桃视频的播放体验确实名副其实，我在信号不太好的地方也能流畅播放，不缓冲这一点真的要给好评。青青草的推荐很靠谱。',
    platform: '蜜桃视频',
    rating: 5,
  },
  {
    name: '社区达人阿杰',
    time: '1周前',
    content: '91视频的社区氛围是最好的，大家讨论很热情，而且评分机制让优质内容更容易被发现。感谢青青草视频做了这么好的聚合整理。',
    platform: '91视频',
    rating: 4,
  },
  {
    name: '追剧小达人',
    time: '1周前',
    content: '樱桃视频虽然内容不多但部部精品，适合对画质有要求的人。樱花视频的更新速度让我惊喜，每天都想刷一刷有没有新片。',
    platform: '樱桃视频 & 樱花视频',
    rating: 5,
  },
  {
    name: '资深影迷老张',
    time: '2周前',
    content: '用了青青草视频大半年了，从最开始只认识一两个平台，到现在六大平台都有涉猎。最喜欢这里的排行和推荐，帮我省了不少找片时间。',
    platform: '青青草视频',
    rating: 5,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="bg-background-50 section-padding">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            真实评价
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            用户口碑
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            来自真实用户的使用反馈与平台评价，为您提供参考
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {commentsData.map((comment, idx) => (
            <div
              key={idx}
              className={`bg-background-50 rounded-xl p-5 border border-background-200/70 ${
                idx === 0 ? 'lg:col-span-2' : ''
              }`}
            >
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${
                      i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                    }`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                &ldquo;{comment.content}&rdquo;
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                    <span className="text-xs font-semibold text-primary-700">
                      {comment.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <div className="text-xs font-medium text-foreground-800">{comment.name}</div>
                    <div className="text-[10px] text-foreground-400">{comment.time}</div>
                  </div>
                </div>
                <span className="text-[10px] text-foreground-400 bg-background-100 px-2 py-1 rounded-full">
                  {comment.platform}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}